import type { InjectionKey, Ref } from 'vue'

/**
 * Threaded from `DSSidebar` down to every row (`DSSidebarItem`,
 * `DSSidebarGroup`, `DSSidebarCollapseToggle`) so callers only pass
 * `collapsed` once, at the root, instead of on every row.
 */
export const SIDEBAR_COLLAPSED: InjectionKey<Ref<boolean>> = Symbol('sidebar-collapsed')

/**
 * Used by overlays rendered via `Teleport` in a collapsed
 * `DSSidebarGroup` flyout to pause hover auto-close while open.
 * Returns a release function to resume auto-close.
 */
export const SIDEBAR_FLYOUT_HOLD_OPEN: InjectionKey<() => () => void> = Symbol('sidebar-flyout-hold-open')
